import { render } from "./HeaderMenu.vue?vue&type=template&id=5435ffa6&scoped=true"
import script from "./HeaderMenu.vue?vue&type=script&lang=js"
export * from "./HeaderMenu.vue?vue&type=script&lang=js"

import "./HeaderMenu.vue?vue&type=style&index=0&id=5435ffa6&scoped=true&lang=css"

import exportComponent from "D:\\Documents\\Development\\carnitas\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5435ffa6"]])

export default __exports__